import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { SlideWrapper } from '../ui/SlideWrapper';
import { Users, Database, Cpu, CheckCircle2, ArrowRight } from 'lucide-react';
const connections = [{
  icon: Users,
  label: 'Menschen'
}, {
  icon: Cpu,
  label: 'Maschinen'
}, {
  icon: Database,
  label: 'Daten'
}];
export function SolutionSlide() {
  return <SlideWrapper data-id="element-194">
      <div className="h-full flex flex-col items-center justify-center" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12" data-id="element-196">
          <h2 className="text-5xl font-bold text-primary mb-4" data-id="element-197">
            Unsere Lösung
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto" data-id="element-198">
            Individuelle Software statt starrer Standardprodukte. Wir bilden
            Ihre realen Prozesse digital ab.
          </p>
        </motion.div>

        {/* Connection Diagram — clean horizontal layout */}
        <div className="w-full max-w-4xl mx-auto mb-12" data-id="element-199">
          {/* Three nodes in a row */}
          <div className="flex items-center justify-center gap-4 md:gap-6 mb-8" data-id="element-200">
            {connections.map((item, i) => <Fragment key={i} data-id="element-201">
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.3 + i * 0.2
            }} className="flex flex-col items-center gap-3 bg-white p-6 md:p-8 rounded-2xl shadow-lg border border-gray-100 flex-1 max-w-[200px]" data-id="element-202">
                  <div className="w-14 h-14 bg-primary/5 rounded-xl flex items-center justify-center" data-id="element-203">
                    <item.icon className="w-7 h-7 text-primary" data-id="element-204" />
                  </div>
                  <span className="font-bold text-primary text-lg" data-id="element-205">
                    {item.label}
                  </span>
                </motion.div>
                {i < connections.length - 1 && <motion.div initial={{
              opacity: 0,
              scale: 0
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.8 + i * 0.2
            }} className="text-accent shrink-0" data-id="element-206">
                    <div className="w-8 md:w-12 h-[2px] bg-accent relative" data-id="element-207">
                      <div className="absolute -top-[3px] -right-1 w-2 h-2 border-t-2 border-r-2 border-accent rotate-45" data-id="element-208" />
                    </div>
                  </motion.div>}
              </Fragment>)}
          </div>

          {/* Central bridge — INTIGOO! as the connecting software layer */}
          <motion.div initial={{
          opacity: 0,
          scaleX: 0
        }} animate={{
          opacity: 1,
          scaleX: 1
        }} transition={{
          delay: 1.2,
          duration: 0.6,
          ease: 'easeOut'
        }} className="relative mx-auto max-w-lg" data-id="element-209">
            <div className="bg-primary rounded-2xl p-6 text-center shadow-xl" data-id="element-210">
              <p className="text-accent font-bold text-sm tracking-widest uppercase mb-1" data-id="element-211">
                Verbunden durch
              </p>
              <p className="text-white font-bold text-xl" data-id="element-212">
                Individuelle Softwarelösungen
              </p>
              <p className="text-white/60 text-sm mt-1" data-id="element-213">
                von INTIGOO! — passgenau für Ihre Abläufe
              </p>
            </div>
            {/* Connector lines up to the nodes */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-[2px] h-4 bg-accent" data-id="element-214" />
          </motion.div>
        </div>

        {/* Benefits */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-10" data-id="element-215">
          {['Effizienz', 'Transparenz', 'Zukunftssicherheit'].map((benefit, i) => <motion.div key={i} className="flex items-center gap-2 text-primary font-semibold text-lg" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1.6 + i * 0.15
        }} data-id="element-216">
                <CheckCircle2 className="text-accent w-5 h-5" data-id="element-217" />
                {benefit}
              </motion.div>)}
        </div>
      </div>
    </SlideWrapper>;
}